import { Suspense, lazy } from 'react';
import { Identifier } from 'src/types/utilityTypes';

const SynchronousVideo = lazy(() => import('./Video/SynchronousVideo'));
interface VideoProps {
  playbackId?: string;
  videoId?: Identifier;
  videoUrl?: string;
  onLoadedData?: () => void;
  downloadable?: boolean;
  refetchInterval?: false | number;
  embedUrl?: string;
}

export const Video = ({ ...props }: VideoProps) => {
  return (
    <Suspense fallback={<></>}>
      <SynchronousVideo {...props}></SynchronousVideo>
    </Suspense>
  );
};
